var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0773 5.53889C11.0773 8.30437 8.00939 11.1845 6.97919 12.074C6.88321 12.1462 6.76639 12.1852 6.64631 12.1852C6.52623 12.1852 6.4094 12.1462 6.31343 12.074C5.28323 11.1845 2.21533 8.30437 2.21533 5.53889C2.21533 4.36372 2.68217 3.23668 3.51314 2.40571C4.3441 1.57474 5.47114 1.10791 6.64631 1.10791C7.82148 1.10791 8.94851 1.57474 9.77948 2.40571C10.6105 3.23668 11.0773 4.36372 11.0773 5.53889Z",
    stroke: "#AD4D34",
    strokeWidth: 1.10774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64648 7.20019C7.56416 7.20019 8.3081 6.45625 8.3081 5.53857C8.3081 4.62088 7.56416 3.87695 6.64648 3.87695C5.72879 3.87695 4.98486 4.62088 4.98486 5.53857C4.98486 6.45625 5.72879 7.20019 6.64648 7.20019Z",
    stroke: "#AD4D34",
    strokeWidth: 1.10774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.7aa9af1b216a92998ff42363ed477761.svg";
export { ForwardRef as ReactComponent };